export const getStatusColor = (status: string): "info" | "default" | "warning" | "error" | "primary" | "secondary" | "success" => {
    switch (status) {
        case "completed":
            return "info";
        case "not_started":
            return "default";
        case "in_progress":
            return "success";
        case "requires_action":
            return "error";
        case "awaiting_decision":
            return "warning";
        default:
            return "default";
    }
}